import type {SVGProps} from 'react';
const CheckboxInactiveIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M15 22H9c-2.6 0-4.3-.5-5.4-1.6S2 17.6 2 15V9c0-2.6.5-4.3 1.6-5.4S6.4 2 9 2h6c2.6 0 4.3.5 5.4 1.6S22 6.4 22 9v6c0 2.6-.5 4.3-1.6 5.4S17.6 22 15 22M9 3.5c-2.1 0-3.5.4-4.3 1.2S3.5 6.9 3.5 9v6c0 2.1.4 3.5 1.2 4.3s2.2 1.2 4.3 1.2h6c2.1 0 3.5-.4 4.3-1.2s1.2-2.2 1.2-4.3V9c0-2.1-.4-3.5-1.2-4.3S17.1 3.5 15 3.5z"
    />
  </svg>
);
export default CheckboxInactiveIcon;
